import React from "react";
import Footer from "../components/utils/Footer";
import Carousel from "../components/carousel/Carousel";
import screenPrintingList from "../components/carousel/screenPrintingList";
import ServiceDescription from "../components/utils/ServiceDescription";
import CallToAction from "../components/utils/CallToAction";
import PhotoGrid from "../components/utils/PhotoGrid";
import Faq from "../components/faq/Faq";
import screenPrintingFaq from "../components/faq/screenPrintingFaq";
import Navbar from "../components/utils/NavBar";
const ScreenPrinting = () => {
  console.log(screenPrintingList);
  return (
    <div className="bg-black">
      <div className="h-[calc(100dvh)] w-screen antialiased overscroll-contain overflow-x-hidden ">
        <Navbar />
        <ServiceDescription
          title={"HYBRID PRINTING"}
          content={`
Offering a versatile and vibrant way to bring designs to life on clothing. We turn ordinary garments into statements by delivering durable and visually striking prints that stand out from the rest.`}
        />
        <Carousel
          CarouselTitle={"What We Can Do For You."}
          breakPoint={" lg:justify-center"}
          CarouselCardList={screenPrintingList}
        />
        <PhotoGrid />
        <CallToAction />
        <Faq questionsList={screenPrintingFaq} />
        <Footer />
      </div>
    </div>
  );
};

export default ScreenPrinting;
